import { useBlocker, useNavigate } from '@tanstack/react-router'
import useNavigationGuardStore from '../stores/useNavigationGuardStore/useNavigationGuardStore'

const NavigationGuard = () => {
    const navigate = useNavigate()
    const hasUnsavedChanges = useNavigationGuardStore(
        (state) => state.hasUnsavedChanges
    )
    const clearNavigationIntent = useNavigationGuardStore(
        (state) => state.clearNavigationIntent
    )
    const setOnNavigationConfirmHandler = useNavigationGuardStore(
        (state) => state.setOnNavigationConfirmHandler
    )
    const onNavigationBlocked = useNavigationGuardStore(
        (state) => state.onNavigationBlocked
    )

    useBlocker({
        shouldBlockFn: ({
            next,
        }: {
            next: {
                routeId: string
                fullPath: string
                pathname: string
                params: Record<string, unknown>
                search: Record<string, unknown>
            }
        }) => {
            if (!useNavigationGuardStore.getState().hasUnsavedChanges) {
                clearNavigationIntent()
                return false
            }

            setOnNavigationConfirmHandler(() => {
                void navigate({ to: next.fullPath })
            })

            if (onNavigationBlocked) {
                onNavigationBlocked()
            }

            return true
        },
        enableBeforeUnload: hasUnsavedChanges,
    })

    return null
}

export default NavigationGuard
